export default "<div class=\"video-player-container\"></div> ";